import { create } from "zustand";
import { IAIData, IMessage, IUserData } from "../@DTO/chat";

// @ts-ignore
import { nanoid } from "nanoid";

interface NewMessageData {
  type: 'human' | 'ai';
  data: IUserData | IAIData;
}

interface ChatState {
  status: string;
  messages: any[];
  newMessageIndex: number | null;
  isAudioMessage: boolean;
  isReceivingMessage: boolean;
  hasReceiveFirstMessage: boolean;
  setStatus: (status: string) => void;
  setMessages: (messages: IMessage[]) => void;
  setNewMessage: (newMessage: NewMessageData) => void;
  setEndMessage: (message: string) => void;
  setBroadcastMessage: (message: {event: string, data: "string"}) => void;
  updateMessage: (message: any) => void;
  errorReceiveMessageManager: () => void;
  reset: () => void;
}
// play notification sound
// const playNotificationSound = () => {
//   const audio = new Audio(notificationSound);
//   audio.volume = 0.35;
//   audio.play();
// };

export const useChatStore = create<ChatState>(set => ({
  status: "",
  messages: [],
  newMessageIndex: null,
  isAudioMessage: false,
  isReceivingMessage: false,
  hasReceiveFirstMessage: false,

  setStatus: status => {
    set({ status });
  },

  setMessages: messages => {
    set({ messages });
  },

  setNewMessage: newMessage => {
    set(state => {
      const isAudio =
        typeof newMessage.data.content === "string" &&
        newMessage.data.content.startsWith("data:audio/");
  
      return {
        messages: [
          ...state.messages,
          {
            type: "human", // User message
            data: {
              content: newMessage.data.content,
              additional_kwargs: {},
              response_metadata: {},
            } as IUserData,
          },
        ],
        newMessageIndex: state.messages.length,
        isAudioMessage: isAudio,
        isReceivingMessage: true,
      };
    });
  },
  
  setEndMessage: (message) => {
    set(state => {
        if (state.messages.length === 0) {
            return {}; 
        }

        return {
            isReceivingMessage: false,
            hasReceiveFirstMessage: true,
        };
    });
},

setBroadcastMessage: (message) => {
  set(state => {
      const content = message.data?.trim(); 

      if (!content) {
          return {}; 
      }

      const lastMessage = state.messages[state.messages.length - 1];

      const shouldCreateNewMessage = !lastMessage || lastMessage.type === "human";

      if (shouldCreateNewMessage) {
          return {
              messages: [
                  ...state.messages,
                  {
                      mId: nanoid(),
                      type: "ai",
                      data: {
                          content: content,
                          tool_calls: [],
                          invalid_tool_calls: [],
                          additional_kwargs: {},
                          response_metadata: {},
                      } as IAIData,
                  },
              ],
              isReceivingMessage: false,
          };
      }

      const updatedMessages = [...state.messages];

      updatedMessages[state.messages.length - 1] = {
          ...updatedMessages[state.messages.length - 1],
          data: {
              ...updatedMessages[state.messages.length - 1].data,
              content: content,
          },
      };

      return {
          messages: updatedMessages,
          isReceivingMessage: false,
      };
  });
},


  updateMessage: updatedMessage => {
    set(state => {
      if (!state.hasReceiveFirstMessage) {
        set({ hasReceiveFirstMessage: true });
      }
  
      const messagesCopy = [...state.messages];
  
      if (state.newMessageIndex !== null) {
        const messageCopy = { ...messagesCopy[state.newMessageIndex] };
        messageCopy.data.content = updatedMessage.content; // Garantimos que `content` seja atualizado
        messagesCopy[state.newMessageIndex] = messageCopy;
      }
  
      return {
        messages: messagesCopy,
      };
    });
  },
  

  errorReceiveMessageManager: () => {
    set(state => {
      if (!state.newMessageIndex) {
        return {};
      }

      const newMessages = state.messages.slice(0, state.newMessageIndex);

      return {
        messages: newMessages,
        isReceivingMessage: false,
        hasReceiveFirstMessage: false,
      };
    });
  },

  reset: () => {
    set({
      isAudioMessage: false,
      newMessageIndex: null,
      isReceivingMessage: false,
      hasReceiveFirstMessage: false,
    });
  },
}));
